export default __webpack_public_path__ + "static/media/subservice81.e782818e.png";